module.exports = __webpack_public_path__ + "static/media/w.305e1246.png";